



let setSession = (key,value)=>{
	try{
		if(value){
			value=JSON.stringify(value)
		}

		sessionStorage.setItem(key, value);
	}catch(e){console.log('set session error',key,value)}
}
let getSession = (key)=>{
	try{
		return JSON.parse(sessionStorage.getItem(key)); 
	}catch(e){
		try{
			sessionStorage.removeItem(key); 
		}catch(e){}
		return "";
	}
}
let getOption = (option)=>{
	let url = window.location.href;
	let opStr = url.indexOf('?')?url.split('?')[1]:"";
	let result = "";
	if(opStr){
		let opItem = opStr.split("&");
		opItem.forEach(function(item,index){
			let opType = item.split("=");
			if(option==opType[0]){
				result = opType[1];
			}
		})
		return result;
	}
	return result;
}
let imgLazy = ()=>{
	let img = document.getElementsByTagName('img');
	for(let i=0 ; i<img.length ; i++){
		let lazyEl = img[i].getAttribute('data-lazy');
		//懒加载需要的节点
		if(lazyEl){
			let top = img[i].getBoundingClientRect().top;
			if(top<getWindowHeight() && !img[i].getAttribute('src')){
				let cls = img[i].getAttribute('class');
				cls = cls+' imgAnimation';
				img[i].setAttribute('src',lazyEl);
				img[i].setAttribute('class',cls);
			}
//						console.log(img[i],img[i].getBoundingClientRect().top)
		}
	}
}

let animationLazy = () => {
	let clsNode = document.getElementsByClassName('ani-lazy');
	for(let i=0 ; i<clsNode.length ; i++){
		let lazyEl = clsNode[i].getAttribute('class');
		//懒加载需要的节点
		if(lazyEl){
			let top = clsNode[i].getBoundingClientRect().top;
			let isExitCls = clsNode[i].getAttribute('class').indexOf('ani-translate');
			if(top<getWindowHeight() && isExitCls==-1){

				let cls = clsNode[i].getAttribute('class');
				cls = cls+' ani-translate';
				clsNode[i].setAttribute('class',cls);
			}
		}
	}
}

let getWindowWidth = () =>{
	return window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
}

let getWindowHeight = () =>{
	return window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
}

//http://192.168.200.117:8081
let getUrl=()=>{
	let url = "https://www.a1life.cn";
	if(process.env.VUE_APP_MODE=='testDist'){
		url="http://test.a1life.cn:8001"
	}
	return url;
}
export default{
		apiUrl:getUrl(),
		windowWidth:getWindowWidth(),
		getWindowHeight:getWindowHeight(),
		setSession:setSession,
		getSession:getSession,
		getOption:getOption,
		imgLazy:imgLazy,
		animationLazy:animationLazy,
//	apiUrl:"http://192.168.200.35:8084",//静态图片地址
//	staticUrl:"https://api.a1life.cn",//静态资源地址
}


{
//	    document.oncontextmenu = function (e) { return false; } //禁止右键
//	    //禁止选择网页中的文字 基本上IE浏览器就不能选中文字复制了
//	    document.onselectstart = function () { return false; }
	    //禁止鼠标拖动图片
	    document.ondragstart = function () { return false; }
	    //IE不支持
//	    document.oncopy = function () { return false; }
			
			let lazyObj = {};
			lazyObj.lazyTimer;
			lazyObj.lazyImgArr = [];//需要懒加载的图片节点
			lazyObj.windowHeight = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
			lazyObj.reLazy = 0;
			
			window.onscroll = function(e){
//				let scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop:document.body.scrollTop;
//				setSession('js-scrollInfo',{top:scrollTop,href:window.location.href})
//				
				if(lazyObj.lazyTimer){
					clearTimeout(lazyObj.lazyTimer)
				}
				lazyObj.lazyTimer = setTimeout(()=>{
					imgLazy();
					animationLazy();
				},50)

			}

}